export var isEmptyBodiedMacro = function isEmptyBodiedMacro(node) {
  var _node$content, _firstGrandChildNode$;
  if (node.type.name !== 'bodiedExtension') {
    return false;
  }
  var firstChildNode = node === null || node === void 0 || (_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.firstChild;
  var firstGrandChildNode = firstChildNode === null || firstChildNode === void 0 ? void 0 : firstChildNode.firstChild;

  // If firstChildNode?.childCount > 1 means there is content along with the placeholder.
  var isEmptyWithPlacholder = (firstGrandChildNode === null || firstGrandChildNode === void 0 || (_firstGrandChildNode$ = firstGrandChildNode.type) === null || _firstGrandChildNode$ === void 0 ? void 0 : _firstGrandChildNode$.name) === 'placeholder' && (firstChildNode === null || firstChildNode === void 0 ? void 0 : firstChildNode.childCount) === 1;
  var isEmptyWithNoContent = !firstGrandChildNode && node.childCount === 1;
  return isEmptyWithPlacholder || isEmptyWithNoContent;
};